"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86192,62788,4989],{

/***/ 32340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio_Radio; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js
var SwitchBase = __webpack_require__(56608);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.root, checked && classes.checked)
  }, /*#__PURE__*/react.createElement(RadioButtonUnchecked, {
    fontSize: fontSize
  }), /*#__PURE__*/react.createElement(RadioButtonChecked, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(79305);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return react.useContext(RadioGroupContext/* default */.Z);
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* fade */.U1)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, {
  checked: true
});
var defaultIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, null);
var Radio = /*#__PURE__*/react.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = (0,createChainedFunction/* default */.Z)(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/react.createElement(SwitchBase/* default */.Z, (0,esm_extends/* default */.Z)({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/react.cloneElement(defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    classes: {
      root: (0,clsx_m/* default */.Z)(classes.root, classes["color".concat((0,capitalize/* default */.Z)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = ((0,withStyles/* default */.Z)(Radio_styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),

/***/ 37661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RadioGroup_RadioGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = /*#__PURE__*/react.forwardRef(function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "row"]);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var FormGroup_FormGroup = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiFormGroup'
})(FormGroup));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(79305);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js










var RadioGroup = /*#__PURE__*/react.forwardRef(function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = react.useRef(null);

  var _useControlled = (0,useControlled/* default */.Z)({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = (0,slicedToArray/* default */.Z)(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  react.useImperativeHandle(actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = (0,unstable_useId/* default */.Z)(nameProp);
  return /*#__PURE__*/react.createElement(RadioGroupContext/* default.Provider */.Z.Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/react.createElement(FormGroup_FormGroup, (0,esm_extends/* default */.Z)({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? 0 : void 0;
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);

/***/ }),

/***/ 79305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext();

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (RadioGroupContext);

/***/ }),

/***/ 23059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'CheckCircleOutline');

exports.Z = _default;

/***/ }),

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var favicon = (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.favicon) ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : ref2.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref3 = datas.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta_image) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref5 = datas.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta_image) === null || ref6 === void 0 ? void 0 : ref6.url,
                name: "image"
            }),
            process.env.NO_INDEX === undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageRoute
            }, "canonical"),
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49841);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79956);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _utils_scrollState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75216);
/* harmony import */ var _Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62788);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);









var Layout = function(param) {
    var children = param.children, doc = param.doc, account = param.account, faq = param.faq, hideTop = param.hideTop, mainLogo = param.mainLogo, headerTitle = param.headerTitle, t = param.t, inStoreText = param.inStoreText, banner = param.banner, metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaKeywords = param.metaKeywords, metaDescriptionProduct = param.metaDescriptionProduct, metaKeywordsProduct = param.metaKeywordsProduct, metaImage = param.metaImage, pageType = param.pageType, takeback = param.takeback, basket = param.basket, pageName = param.pageName;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var scrollState = (0,_utils_scrollState__WEBPACK_IMPORTED_MODULE_5__/* .useScrollState */ .M)();
    var isBanner = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(banner === null || banner === void 0 ? void 0 : (ref = banner.data) === null || ref === void 0 ? void 0 : ref.text);
    var isDisplayedBannerOnAllPages = banner === null || banner === void 0 ? void 0 : (ref1 = banner.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var metaTitleString = metaTitle && (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.baseline) ? "".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.baseline), " - ").concat(metaTitle) : metaTitle;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('page', pageType && "page--".concat(pageType)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__["default"], {
                datas: doc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: [
                    metaTitleString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: metaTitleString
                            }, "pageTitle"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                name: "title",
                                content: metaTitleString
                            })
                        ]
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescription
                    }),
                    (metaKeywords === null || metaKeywords === void 0 ? void 0 : metaKeywords.length) && ((ref4 = metaKeywords[0]) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(metaKeywords)
                    }),
                    metaKeywordsProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: metaKeywordsProduct
                    }),
                    metaDescriptionProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescriptionProduct
                    }),
                    metaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: metaImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: metaImage
                            })
                        ]
                    })
                ]
            }),
            !(doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.hide_header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                logo: mainLogo,
                t: t,
                title: headerTitle,
                inStoreText: inStoreText,
                doc: doc,
                account: account,
                faq: faq,
                showOnScrollUp: scrollState.showOnScrollUp,
                showOnTop: scrollState.showOnTop,
                textColor: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.header_text_color,
                background: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.header_background,
                hoverColor: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.header_text_hover_color,
                basket: basket,
                takeback: takeback,
                submenuBackgroundColor: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.header_submenu_background_color,
                submenuTextColor: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.header_submenu_text_color,
                isBanner: isBanner,
                isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
                banner: banner,
                pageName: pageName
            }),
            children,
            !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                doc: doc,
                t: t,
                hideTop: hideTop
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 46194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ postProductToReturn; },
/* harmony export */   "Fh": function() { return /* binding */ getOrderInvoice; },
/* harmony export */   "pV": function() { return /* binding */ getProductReturningReasons; }
/* harmony export */ });
/* unused harmony exports ACTIONS, POST_PRODUCT_TO_RETURN_REQUEST, POST_PRODUCT_TO_RETURN_SUCCESS, POST_PRODUCT_TO_RETURN_FAILURE, SAVE_PRODUCT_TO_RETURN_SUCCESS, saveProductToReturn, GET_ORDER_INVOICE_REQUEST, GET_ORDER_INVOICE_SUCCESS, GET_ORDER_INVOICE_FAILURE, GET_PRODUCT_RETURNING_REASONS_REQUEST, GET_PRODUCT_RETURNING_REASONS_SUCCESS, GET_PRODUCT_RETURNING_REASONS_FAILURE */
/* harmony import */ var _services_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39490);

var ACTIONS = {
    POST_PRODUCT_TO_RETURN_REQUEST: 'POST_PRODUCT_TO_RETURN_REQUEST',
    POST_PRODUCT_TO_RETURN_SUCCESS: 'POST_PRODUCT_TO_RETURN_SUCCESS',
    POST_PRODUCT_TO_RETURN_FAILURE: 'POST_PRODUCT_TO_RETURN_FAILURE',
    SAVE_PRODUCT_TO_RETURN_SUCCESS: 'SAVE_PRODUCT_TO_RETURN_SUCCESS',
    GET_ORDER_INVOICE_REQUEST: 'GET_ORDER_INVOICE_REQUEST',
    GET_ORDER_INVOICE_SUCCESS: 'GET_ORDER_INVOICE_SUCCESS',
    GET_ORDER_INVOICE_FAILURE: 'GET_ORDER_INVOICE_FAILURE',
    GET_PRODUCT_RETURNING_REASONS_REQUEST: 'GET_PRODUCT_RETURNING_REASONS_REQUEST',
    GET_PRODUCT_RETURNING_REASONS_SUCCESS: 'GET_PRODUCT_RETURNING_REASONS_SUCCESS',
    GET_PRODUCT_RETURNING_REASONS_FAILURE: 'GET_PRODUCT_RETURNING_REASONS_FAILURE'
};
var POST_PRODUCT_TO_RETURN_REQUEST = function() {
    return {
        type: ACTIONS.POST_PRODUCT_TO_RETURN_REQUEST
    };
};
var POST_PRODUCT_TO_RETURN_SUCCESS = function(response) {
    return {
        type: ACTIONS.POST_PRODUCT_TO_RETURN_SUCCESS,
        response: response
    };
};
var POST_PRODUCT_TO_RETURN_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_PRODUCT_TO_RETURN_FAILURE,
        err: err
    };
};
function postProductToReturn(data) {
    return function(dispatch) {
        dispatch(POST_PRODUCT_TO_RETURN_REQUEST());
        return _services_order__WEBPACK_IMPORTED_MODULE_0__/* .postProductToReturn */ .Gv(data).then(function(response) {
            return dispatch(POST_PRODUCT_TO_RETURN_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_PRODUCT_TO_RETURN_FAILURE(err));
        });
    };
}
var SAVE_PRODUCT_TO_RETURN_SUCCESS = function(response) {
    return {
        type: ACTIONS.SAVE_PRODUCT_TO_RETURN_SUCCESS,
        response: response
    };
};
function saveProductToReturn(data) {
    return function(dispatch) {
        dispatch(SAVE_PRODUCT_TO_RETURN_SUCCESS(data));
    };
}
var GET_ORDER_INVOICE_REQUEST = function() {
    return {
        type: ACTIONS.GET_ORDER_INVOICE_REQUEST
    };
};
var GET_ORDER_INVOICE_SUCCESS = function(invoice) {
    return {
        type: ACTIONS.GET_ORDER_INVOICE_SUCCESS,
        invoice: invoice
    };
};
var GET_ORDER_INVOICE_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_ORDER_INVOICE_FAILURE,
        err: err
    };
};
function getOrderInvoice(orderToken) {
    return function(dispatch) {
        dispatch(GET_ORDER_INVOICE_REQUEST());
        return _services_order__WEBPACK_IMPORTED_MODULE_0__/* .getOrderInvoice */ .Fh(orderToken).then(function(response) {
            return dispatch(GET_ORDER_INVOICE_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_ORDER_INVOICE_FAILURE(err));
        });
    };
}
var GET_PRODUCT_RETURNING_REASONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_REQUEST
    };
};
var GET_PRODUCT_RETURNING_REASONS_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_SUCCESS,
        response: response
    };
};
var GET_PRODUCT_RETURNING_REASONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_FAILURE,
        err: err
    };
};
function getProductReturningReasons(locale) {
    return function(dispatch) {
        dispatch(GET_PRODUCT_RETURNING_REASONS_REQUEST());
        return _services_order__WEBPACK_IMPORTED_MODULE_0__/* .getProductReturningReasons */ .pV(locale).then(function(response) {
            return dispatch(GET_PRODUCT_RETURNING_REASONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PRODUCT_RETURNING_REASONS_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 39490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ postProductToReturn; },
/* harmony export */   "Fh": function() { return /* binding */ getOrderInvoice; },
/* harmony export */   "pV": function() { return /* binding */ getProductReturningReasons; },
/* harmony export */   "k": function() { return /* binding */ getOrderReturnLabel; }
/* harmony export */ });
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16502);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12664);
/* harmony import */ var _helpers_requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20031);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66026);




var authHeaders = function() {
    var token = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN);
    return token ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)) : {};
};
var postProductToReturn = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        origin: "https://millet-admin.lizee.io/",
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl["return"] */ .KU["return"],
        data: data,
        headers: authHeaders()
    });
};
var getOrderInvoice = function(orderToken) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.invoice */ .KU.invoice,
        uid: orderToken + '/invoice/download'
    });
};
var getProductReturningReasons = function(locale) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.productReturningReasons */ .jo.productReturningReasons,
        uid: locale
    });
};
var getOrderReturnLabel = function(omsOrderId) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.rightOfWithdrawal */ .jo.rightOfWithdrawal,
        uid: "".concat(omsOrderId, "/return-label"),
        headers: authHeaders()
    });
};


/***/ })

}]);